import * as Tabs from "@radix-ui/react-tabs";
import "./FiresideSessionPage.scss";
import React, { useMemo } from "react";
import VimeoPlayer from "../VimeoPlayer";

interface SubscreenInfo {
  title: string;
  description: string;
  subject: string;
  organization: string;
  vimeoId: number;
  vimeoHValue: string;
}

// tab label, video id, title
const TabData: SubscreenInfo[] = [
  {
    title: "Own Your Career",
    description: "How to take ownership of your career.",
    subject: "Sherina Edwards, Board Member",
    organization: "SouthWest Water Company",
    vimeoId: 811338319,
    vimeoHValue: "ad370e415d",
  },
  {
    title: "Be Impactful",
    description: "Pro tips on how to have influence, regardless of title.",
    subject: "Hilda Pinnix-Ragland, Board Member",
    organization: "SouthWest Water Company",
    vimeoId: 814361980,
    vimeoHValue: "cfa4d8b50b",
  },
  {
    title: "Work Efficiently",
    description: "Advice/ideas for focus and time management.",
    subject: "Andrew Turner, Head of Communications",
    organization: "Diageo North America",
    vimeoId: 838680282,
    vimeoHValue: "229b89402f",
  },
  {
    title: "Own Your Satisfaction",
    description: "How to successfully advocate for your needs.",
    subject: "Conor Jensen, VP of Data Science",
    organization: "Dataiku",
    vimeoId: 811337375,
    vimeoHValue: "5027b30b96",
  },
  {
    title: "Partner with Your Manager",
    description: "Keys to great manager relationships.",
    subject: "Dana Basile, Chief Operating Officer",
    organization: "Hearts & Science",
    vimeoId: 816316437,
    vimeoHValue: "6173fc9b76",
  },
  {
    title: "Own Your Inclusion",
    description: "Formative experiences that shape who you are.",
    subject: "Hilda Pinnix-Ragland, Board Member",
    organization: "SouthWest Water Company",
    vimeoId: 815091143,
    vimeoHValue: "b3dc9d3326",
  },
  {
    title: "Keep Growing",
    description: "How to keep challenging yourself and growing.",
    subject: "Susan Stewart, Head of Global Talent",
    organization: "Nestle USA",
    vimeoId: 838682894,
    vimeoHValue: "496b707707",
  },
];

interface FiresideSessionPageProps {}

const FiresideSessionPage: React.FC<FiresideSessionPageProps> = (props) => {
  const [currentTab, setCurrentTab] = React.useState(0);
  const currentData = useMemo(() => TabData[currentTab], [currentTab]);

  return (
    <div className="FiresideSessionPage">
      <header>
        <h1>Fireside Chats Reinforce Program Topics</h1>
        <p>
          Fireside Chats give executives the opportunity to share their wisdom
          about the developmental components of PILOT. Executives drive home and
          reinforce these topics, revealing the unwritten rules of work for
          employees.
        </p>
      </header>
      <Tabs.Root
        className="TabsRoot VerticalTabs"
        orientation="vertical"
        defaultValue="0"
        onValueChange={(newVal) => setCurrentTab(Number(newVal))}
      >
        <Tabs.List className="TabsList">
          {TabData.map((tab, i) => (
            <Tabs.Trigger key={i} value={`${i}`}>
              <h3>{tab.title}</h3>
              <h4>{tab.description}</h4>
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        <Tabs.Content className="TabsContent" value={`${currentTab}`}>
          <VimeoPlayer
            videoId={currentData.vimeoId}
            hValue={currentData.vimeoHValue}
            title={currentData.title}
          />
          <h5>
            {currentData.subject} - {currentData.organization}
          </h5>
        </Tabs.Content>
      </Tabs.Root>
    </div>
  );
};

export default FiresideSessionPage;
